import { Component, computed, effect, inject, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { AbstractControl, FormGroup, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { map, switchMap } from 'rxjs';

@Component({
  selector: 'ez-checkbox-input',
  imports: [ReactiveFormsModule],
  templateUrl: './checkbox-input.component.html',
  styleUrl: './checkbox-input.component.scss',
})
export class CheckboxInputComponent {
  private readonly rootFormGroup = inject(FormGroupDirective);

  get form(): FormGroup {
    return this.rootFormGroup.control;
  }

  readonly isDisabled = input<boolean>(false);
  readonly name = input<string>();
  readonly controlName = input.required<string>();
  readonly altText = input<string>();
  readonly isContentVisible = input<boolean>(true);
  readonly required = input<boolean>(false);

  readonly control = computed<AbstractControl>(() => this.form.get(this.controlName())!);

  readonly errorMessage = toSignal(
    toObservable(this.control).pipe(switchMap((control) => control.events.pipe(map(() => this.currentErrorMessage())))),
    { initialValue: null },
  );

  constructor() {
    effect(() => {
      const control = this.control();
      if (this.isDisabled()) {
        control.disable();
      } else {
        control.enable();
      }
    });
  }

  private currentErrorMessage(): string | null {
    const control = this.control();
    if (!control.invalid || !(control.dirty || control.touched)) {
      return null;
    }
    if (control.errors?.['required']) {
      return 'Fehler: Dies ist ein Pflichtfeld.';
    }
    return 'Fehlerhafte Eingabe.';
  }
}
